import React, { useState } from 'react';
import {
  Box,
  InputProps,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Text,
  Icon,
  useDisclosure,
} from '@chakra-ui/react';
import { InputCustom } from '../UI';
import { searchByVINAction } from '../../../modules/catalog/actions';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import { routes } from '../../../constants/routes';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { SearchIcon } from '@chakra-ui/icons';

export const SearchBarWithResults: React.FC<InputProps> = ({ ...props }) => {
  const [inputValue, setInputValue] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { searchText } = useParams();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const searchByVIN = useAppSelector(state => state.catalog.searchByVIN);
  // const searchDetails = useAppSelector(state => state.carts.serchDetailsBySuppliers);
  // const searchDetailsLoading = useAppSelector(
  //   state => state.carts.isLoading.serchDetailsBySuppliers,
  // );
  const searchByVINLoading = useAppSelector(state => state.catalog.isLoading.searchByVIN);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  // console.log(searchDetails, 'searchDetails');

  // // useEffect(() => {
  // if (
  //   !searchByVIN?.vins?.length &&
  //   !searchByVIN?.marks?.length &&
  //   // searchDetails?.length &&
  //   !searchByVINLoading
  //   // !searchDetailsLoading
  // ) {
  //   navigate(
  //     generatePath(routes.CATALOG_SEARCH_BAR_RESULTS, {
  //       searchText: inputValue,
  //     }),
  //   );
  //   // navigate(routes.CATALOG_SEARCH_BAR_RESULTS);
  //   onClose();
  // }
  // // }, [searchByVIN, searchByVINLoading, inputValue]);

  const handleSearch = () => {
    dispatch(searchByVINAction.request(inputValue));
    if (inputValue.trim().length < 16) {
      navigate(
        generatePath(routes.CATALOG_SEARCH_BAR_RESULTS, {
          searchText: inputValue,
        }),
      );
    } else {
      onOpen();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleResultClick = (vin: {
    type: string;
    mark: string;
    model: string;
    modification: string;
    nextStep?: string;
  }) => {
    const step =
      vin.nextStep === 'modifications' ? routes.CATALOG_MODIFICATION : routes.CATALOG_GROUPS;
    navigate(step);
    onClose();
  };

  return (
    <>
      <Box display="flex" alignItems="center" maxW="675px" w="100%" position="relative">
        <InputCustom
          {...props}
          value={inputValue}
          onChange={handleInputChange}
          borderColor={typeof props.borderColor === 'string' ? props.borderColor : '#111'}
          placeholder="Введите номер детали или VIN"
          hasSearchIcon
          backgroundColor={
            typeof props.backgroundColor === 'string' ? props.backgroundColor : '#ECECEC'
          }
          spaceSize={0}
          onSearchIconClick={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </Box>

      {/* Модальное окно для результатов поиска */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Результаты поиска {searchText}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!searchByVIN?.vins?.length && !searchByVIN?.marks?.length ? (
              <VStack align="center" justify="center" h="300px" spacing={4}>
                <Icon as={SearchIcon} boxSize="100px" color="gray.300" />
                <Text fontSize="2xl" color="gray.500">
                  Ничего не найдено
                </Text>
              </VStack>
            ) : (
              <VStack align="start" spacing={4}>
                {/* Результаты поиска по VIN */}
                {searchByVIN?.vins && searchByVIN.vins.length > 0 && (
                  <Box w="100%">
                    <Text fontSize="2xl" fontWeight="bold">
                      Результаты по VIN:
                    </Text>
                    {searchByVIN.vins.map((vin, index) => (
                      <Box
                        key={index}
                        p={4}
                        bg="white"
                        borderRadius="md"
                        shadow="md"
                        mb={4}
                        onClick={() => handleResultClick(vin)}
                        _hover={{ cursor: 'pointer', backgroundColor: 'gray.200' }}
                      >
                        <VStack align="start">
                          <Text fontSize="xl" fontWeight="bold">
                            {vin.markName} {vin.modelName}
                          </Text>
                          <Text>Тип: {vin.type}</Text>
                          <Text>Модификация: {vin.modification}</Text>
                        </VStack>
                      </Box>
                    ))}
                  </Box>
                )}

                {/* {searchDetails && searchDetails.length > 0 && (
                  <Box w="100%">
                    <Text fontSize="2xl" fontWeight="bold">
                      Информация о товаре:
                    </Text>
                    {searchDetails.map((supplier, index) => (
                      <Box key={index} p={4} bg="white" borderRadius="md" shadow="md" mb={4}>
                        <VStack align="start">
                          <Text fontSize="xl" fontWeight="bold">
                            {supplier.name} ({supplier.brand})
                          </Text>
                          <Text>Цена: {supplier.price} руб.</Text>
                        </VStack>
                      </Box>
                    ))}
                  </Box>
                )} */}
              </VStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
